
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.454 5.283a3 3 0 000 4.242l1.867 1.867a1 1 0 001.413 0l5.663-5.65a1 1 0 000-1.415L9.526 2.454a3 3 0 00-4.242 0L2.454 5.283zM12.804 19.875a1 1 0 010-1.413l5.65-5.663a1 1 0 011.415 0l1.677 1.676a3 3 0 010 4.243l-2.828 2.828a3 3 0 01-4.243 0l-1.67-1.67zM16.867 3.086a2 2 0 012.829 0L21.11 4.5a2 2 0 010 2.828l-.707.708a1 1 0 01-1.414 0L16.16 5.207a1 1 0 010-1.414l.707-.707zM14.746 6.621a1 1 0 00-1.414 0l-9.365 9.365a1 1 0 00-.253.427l-1.17 4.017a1 1 0 001.244 1.239l3.997-1.187a1 1 0 00.423-.251l9.367-9.367a1 1 0 000-1.414L14.745 6.62z"}})])
          )
        }
      }
    